import { Link } from 'react-router-dom';
import StoryCard from '@/components/feature/StoryCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { stories } from '@/mocks/stories';

export default function HotSection() {
  const featured = stories.find((s) => s.featured && s.hot) ?? stories[0];
  const hotList = [...stories]
    .filter((s) => s.id !== featured.id)
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  return (
    <section className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            eyebrow="今日热瓜"
            title="校园里今天最热闹的五件事"
            desc="编辑每天从读者投稿和校园观察里挑出讨论度最高的故事，先看这篇，再决定从哪儿开始围观。"
          />
          <Link
            to="/stories"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部趣闻 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <StoryCard story={featured} variant="wide" />
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100/60 p-5 lg:col-span-5 lg:p-6">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-fire-line text-primary-500" />
              围观热度榜
            </h3>
            <div className="mt-3">
              {hotList.map((story, i) => (
                <StoryCard key={story.id} story={story} variant="compact" index={i} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}